import { LoadingButton } from "@mui/lab";
import { Box, Grid, Typography } from "@mui/material";
import {
  BentoCategory,
  OrganizationNiche,
  TemplateIntakeForm,
} from "schemas/dashboard";
import { CustomEvent } from "schemas/functions";

import Niche from "features/Auth/SelfServeVaOnboarding/NichePick/Niche";

interface Props {
  categoriesToPickFrom: BentoCategory[];
  handleNext: (e: CustomEvent) => void;
  niches: OrganizationNiche[];
  setNiches: React.Dispatch<React.SetStateAction<OrganizationNiche[]>>;
  saveLoading: boolean;
  templateIntakeForms: TemplateIntakeForm[];
}

const NicheForm = ({
  categoriesToPickFrom,
  handleNext,
  niches,
  setNiches,
  saveLoading,
  templateIntakeForms,
}: Props) => {
  return (
    <>
      <Typography variant="h3" gutterBottom sx={{ textAlign: "center", mt: 0 }}>
        Select Your Niches
      </Typography>
      <form onSubmit={handleNext}>
        {Array.from({ length: niches?.length }, (_, index) => (
          <Niche
            key={index}
            niche={niches[index]}
            niches={niches}
            setNiches={setNiches}
            index={index}
            categoriesToPickFrom={categoriesToPickFrom}
            templateIntakeForms={templateIntakeForms}
          />
        ))}
        <Grid item xs="auto" container columnGap={1} sx={{ mt: 4 }}>
          <Grid item xs="auto"></Grid>
          <Grid item xs></Grid>
          <Grid item xs="auto">
            <LoadingButton disableElevation type="submit" loading={saveLoading}>
              Next
              <Box
                component="i"
                className="fa-solid fa-arrow-right"
                sx={{ ml: 1 }}
              />
            </LoadingButton>
          </Grid>
        </Grid>
      </form>
    </>
  );
};

export default NicheForm;
